// src/pages/lgbtqia/CareBundle.js
import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, FormGroup, FormControlLabel, Checkbox, TextField, Button, Alert } from '@mui/material';

const useQuery = () => new URLSearchParams(useLocation().search);

export default function CareBundle() {
  const q = useQuery();
  const citizenId = q.get('citizenId') || '';
  const storageKey = useMemo(() => `lgbtqia-care:${citizenId || 'unspecified'}`, [citizenId]);
  const [msg, setMsg] = useState('');
  const [checks, setChecks] = useState(() => {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null') || {}; } catch { return {}; }
  });
  const toggle = (k) => setChecks((c) => ({ ...c, [k]: !c[k] }));

  const save = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(checks)); setMsg('Saved.'); } catch {}
  };

  return (
    <Box className="p-6">
      <Typography variant="h5" sx={{ mb: 2 }}>Care Bundle</Typography>
      {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}

      <FormGroup>
        <FormControlLabel control={<Checkbox checked={!!checks.prep} onChange={()=>toggle('prep')} />} label="PrEP counselling and eligibility" />
        <FormControlLabel control={<Checkbox checked={!!checks.pep} onChange={()=>toggle('pep')} />} label="PEP counselling (if exposure)" />
        <FormControlLabel control={<Checkbox checked={!!checks.sti} onChange={()=>toggle('sti')} />} label="STI screen (HIV, Syphilis, HBV, HCV, others)" />
        <FormControlLabel control={<Checkbox checked={!!checks.vax} onChange={()=>toggle('vax')} />} label="Vaccinations (HBV, HPV, Influenza as indicated)" />
        <FormControlLabel control={<Checkbox checked={!!checks.mental} onChange={()=>toggle('mental')} />} label="Mental health referral" />
      </FormGroup>

      <TextField label="Notes" fullWidth multiline sx={{ mt: 2 }} value={checks.notes || ''} onChange={(e)=>setChecks(c=>({...c, notes:e.target.value}))} />

      <Button variant="contained" sx={{ mt: 2 }} onClick={save}>Save</Button>
    </Box>
  );
}
